import React from "react";
import { Modal } from "react-bootstrap";
import PointsService from "../../../services/management/PointsService";
import StudentService from "../../../services/student/StudentService";
import RowField from "../../shared/row-field/RowField";
import TopUsersModalStates, { TopUsersModalProps } from "./TopUsersModal.models";
import './TopUsersModal.scss';
import image from '../../../assest/images/content/star.png';
import imageForm from '../../../assest/images/content/success.png';

export default class TopUsersModal extends React.PureComponent<TopUsersModalProps, TopUsersModalStates>{
    pointsService: PointsService;
    studentService: StudentService;
    constructor(props: TopUsersModalProps) {
        super(props);
        this.state = { points: [], details: { examPrecent: 0, reportTime: { text: '', hour: 0, minute: 0 } } };
        this.pointsService = new PointsService();
        this.studentService = new StudentService();
    }
    componentDidMount() {
        if (this.props.studentId !== null && this.props.studentId !== undefined)
            this.getData();
    }
    componentDidUpdate(prevProps: TopUsersModalProps) {
        if (this.props.studentId !== null && this.props.studentId !== undefined && prevProps.studentId !== this.props.studentId)
            this.getData();
    }
    getData = () => {
        this.getDetails();
        this.getPoins();
    }

    getPoins = () => {
        let state = this;
        this.pointsService.getReceivedPointList(this.props.studentId).then(response => {
            state.setState({ points: response });
        })
    }

    getDetails = () => {
        let state = this;
        this.studentService.getStudentAverageDetails(this.props.studentId).then(response => {
            state.setState({ details: response });
        })
    }

    render(): React.ReactNode {
        let { showModal, closeModal, orderId, point, name } = this.props;
        let { points, details } = this.state;
        let buttonStyle = { backgroundColor: "#25b3c9" };
        return <>
            <Modal show={showModal} onHide={closeModal} animation={true}>
                {/* <Modal.Header >
                    <Modal.Title dir="rtl">
                        <div className="text-center">
                            برترین های برنده ساز
                        </div>
                    </Modal.Title>
                </Modal.Header> */}

                <Modal.Body>
                    <div className="col-12 top-users-modal">
                        <div className="tk-card">
                            <div className="card-icon">
                                <img src={imageForm} alt="education content menu" width={64} height={64} />
                            </div>
                            <div className="card-title ">
                                <label>رکورد های دانش آموز</label>
                            </div>
                            <div className="col-12 user-info" >
                                <div className="tk-inline">
                                    <div className="col-6 notspace title" >
                                        <label>:نام و نام خانوادگی</label>
                                    </div>
                                    <div className="col-6 notspace info">
                                        <label>
                                            {name}
                                        </label>
                                    </div>
                                </div>
                                <div className="tk-inline">
                                    <div className="col-6 notspace title" >
                                        <label>:رتبه</label>
                                    </div>
                                    <div className="col-6 notspace info">
                                        <label>
                                            {orderId}
                                        </label>
                                    </div>
                                </div>
                                <div className="tk-inline">
                                    <div className="col-6 notspace title" >
                                        <label>:امتیاز</label>
                                    </div>
                                    <div className="col-6 notspace info">
                                        <label>
                                            {point}
                                        </label>
                                    </div>
                                </div>
                                <div className="tk-inline">
                                    <div className="col-8 notspace title" >
                                        <label>:میانگین ساعت مطالعه </label>
                                    </div>
                                    <div className="col-4 notspace info">
                                        <label className="button-box">{details.reportTime.hour}:{details.reportTime.minute}</label>
                                    </div>
                                </div>
                                {/* <div className="tk-inline ">
                                    <div className="col-6 notspace title" >
                                        <label>:درصد آزمون</label>
                                    </div>
                                    <div className="col-6 notspace info">
                                        <label className="button-box">{details.examPrecent}%</label>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>

                    <div className="col-12  notspace mt-4 text-right" >
                        <label>لیست امتیازات کسب شده</label>
                    </div>
                    <div className="overflow-scroll">
                        {points.map((point, key) => {
                            return <RowField key={key} details={{ title: `${point.pointTitle}`, subTitle: '', showButton: true, imageSource: image, buttonText: point.point.toString(), buttonStyle: buttonStyle }} />;
                        })}
                    </div>
                </Modal.Body >

                <Modal.Footer dir="ltr">
                    <button className="btn btn btn-primary tk-float-left" onClick={closeModal}>بستن</button>
                </Modal.Footer>
            </Modal>
        </>
    }
}